import { render, staticRenderFns } from "./IconStorage.vue?vue&type=template&id=fb3e75b6&"
import script from "./IconStorage.vue?vue&type=script&lang=js&"
export * from "./IconStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3e75b6')) {
      api.createRecord('fb3e75b6', component.options)
    } else {
      api.reload('fb3e75b6', component.options)
    }
    module.hot.accept("./IconStorage.vue?vue&type=template&id=fb3e75b6&", function () {
      api.rerender('fb3e75b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconStorage.vue"
export default component.exports